
const concatinateMessages = (m1:any, m2:any, m3:any, m4:any, m5:any, m6:any) => {
    let res = m1
    if (m2 || _.isBoolean(m2)) res+=" "+m2
    if (m3 || _.isBoolean(m3)) res+=" "+m3
    if (m4 || _.isBoolean(m4)) res+=" "+m4
    if (m5 || _.isBoolean(m5)) res+=" "+m5
    if (m6 || _.isBoolean(m6)) res+=" "+m6
    return res
}

export interface ConsoleExtended {


    log:    typeof console.log
    error:    typeof console.error
    warn:    typeof console.warn

    print   : any
    green   : any
    orange   : any
    red   : any
    blue   : any
    purple()   : void
    brown   : any

}


export default function extendConsole() {



    // @ts-ignore
    console.print = (...args) => {

        const updatedArgs = _.map(args, (val)=>{

            // format moment
            if (val && val._isAMomentObject) {
                val = "{" + val.format("YYYY-MM-DD") + "}"
            } else {
                // val = JSON.stringify(val)
            }

            return val;
        })


        console.log(...updatedArgs)
    }

    // @ts-ignore
    console.green = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: green;');
    }

    // @ts-ignore
    console.orange = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: orange;');
    }

    // @ts-ignore
    console.red = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: red;');
    }

    // @ts-ignore
    console.blue = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: blue;');
    }

    // @ts-ignore
    console.purple = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: #800080;')
    }

    // @ts-ignore
    console.brown = (m1, m2="", m3="", m4="", m5="", m6="") => {
        const message = concatinateMessages(m1, m2, m3, m4, m5, m6)
        console.log('%c'+message, 'color: brown;')
    }




}